export type navIndex =
	| "Home"
	| "Schedules"
	| "Criteria"
	| "Runs"
	| "Inventory"
	| "InventoryUpdates"
	| "DisplayRequired";

export type navIcon =
	| "ScheduleOutlined"
	| "ListAltOutlined"
	| "DirectionsRunOutlined"
	| "InventoryOutlined";

type leftNavMenuItem = {
	name: string;
	index: navIndex;
	icon: navIcon;
	order: number;
};

const consts = {
	routerPath: {
		home: "/",
		schedules: "/schedules",
		criteria: "/criteria",
		inventory: "/inventory",
		inventoryUpdates: "/inventory/updates",
		inventoryDisplayRequired: "/inventory/displayrequired"
	},
	leftNav: [
		{
			name: "Schedules",
			index: "Schedules",
			icon: "ScheduleOutlined",
			order: 1,
		},
		{
			name: "Criteria",
			index: "Criteria",
			icon: "ListAltOutlined",
			order: 2,
		},
		{
			name: "Inventory",
			index: "Inventory",
			icon: "InventoryOutlined",
			order: 3,
		}
	] as Array<leftNavMenuItem>,
};
export default consts;
